import React from 'react'

import { Pressable } from 'widgets/Pressable'
import { Text, TextProps } from 'widgets/Text'

interface PressableTextProps extends TextProps {
  onPress?: () => void
  disabled?: boolean
}

export const PressableText = ({
  onPress,
  disabled = false,
  children,
  ...rest
}: PressableTextProps) => {
  return (
    <Pressable onPress={onPress} disabled={disabled}>
      <Text {...rest}>{children}</Text>
    </Pressable>
  )
}
